<template>
  <div class="current-legend">
    <div class="current-legend__color-blocks">
      <div
        class="current-legend__color-blocks__block"
        v-for="d in dataInfos"
        :key="d.value"
        :style="{
          width: `${100 / dataInfos.length}%`,
          'background-color': d.color
        }"
      ></div>
    </div>
    <div class="current-legend__lower">
      more spending ⟶
    </div>
  </div>
</template>

<script>
import { getColorScaleCurrent } from '@/utils/dataUtils'
export default {
  data() {
    return {}
  },
  computed: {
    dataInfos() {
      const scale = getColorScaleCurrent({
        isCurrent: true,
        metric: 'ALL_ENERGY'
      })

      const domainLength = scale.domain()[1] - scale.domain()[0]

      const values = [
        scale.domain()[0],
        Math.round(scale.domain()[0] + domainLength / 3),
        Math.round(scale.domain()[0] + (domainLength / 3) * 2),
        scale.domain()[1]
      ]

      const retVal = values.map(value => {
        return { value, color: scale(value) }
      })

      return retVal
    },
    labelInfos() {
      return [this.dataInfos[0], this.dataInfos[this.dataInfos.length - 1]].map(
        el => el.value
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.current-legend {
  position: absolute;

  width: 150px;
  height: 50px;
  display: flex;
  flex-flow: column;
  &__color-blocks {
    height: 30px;
    position: relative;
    display: flex;
    &__block {
      height: 100%;
    }
  }

  &__lower {
    display: flex;
    justify-content: center;
    font-size: 12px;
  }
}
</style>
